import { render, staticRenderFns } from "./IntentForm.vue?vue&type=template&id=f88c5cf6&scoped=true&"
import script from "./IntentForm.vue?vue&type=script&lang=js&"
export * from "./IntentForm.vue?vue&type=script&lang=js&"
import style0 from "./IntentForm.vue?vue&type=style&index=0&id=f88c5cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88c5cf6",
  null
  
)

export default component.exports